module.exports = __webpack_public_path__ + "static/media/employee-trophy.b9e00878.svg";